import { useEffect } from 'react'
import useBarryController from 'components/Barry/hooks/useBarryController '
import useBarryDashboard from 'components/Barry/hooks/useBarryDashboard'

export default function useBarryIconVisibilityDashboard(): void {
  const { setBarryIconVisibility, isBarryDialogOpen } = useBarryController()
  const { hasProvisioningHelpPopup } = useBarryDashboard()

  //Closing an opened barry window should also hide the icon on dashboard
  useEffect(() => {
    setBarryIconVisibility(isBarryDialogOpen || hasProvisioningHelpPopup)

    return () => {
      setBarryIconVisibility(true)
    }
  }, [isBarryDialogOpen, setBarryIconVisibility, hasProvisioningHelpPopup])
}
